import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import AnimateHeight from "react-animate-height";

import * as styles from "./single-faq.module.scss";
import { config } from "../../config";
import { useTranslation } from "../../hooks/use-translation";
import { IQuestion } from "../../models/structured-data.model";

const { translationKeys } = config;

export interface ISingleFaq {
    translations: {
        [key: string]: {
            question?: string;
            answer?: string;
        };
    };
}

export interface ISingleFaqProps {
    data: ISingleFaq;
    onCreateQuestion?: (question: IQuestion) => void;
}

const SingleFaq: React.FC<ISingleFaqProps> = ({ data, onCreateQuestion = () => {} }) => {
    const { question, answer } = useTranslation(data, translationKeys.singleFaq);
    const [isFaqOpen, setIsFaqOpen] = useState(false);

    useEffect(() => {
        onCreateQuestion({ name: question, acceptedAnswer: { text: answer } });
    }, [onCreateQuestion, question, answer]);

    return (
        <article className={`${styles.faq} ${isFaqOpen ? styles.faqOpen : ""}`}>
            <button
                type="button"
                className={styles.question}
                aria-expanded={isFaqOpen}
                onClick={() => setIsFaqOpen(open => !open)}
            >
                <span>{question}</span>
                <span className={styles.chevron} aria-hidden="true">V</span>
            </button>
            <AnimateHeight
                className={styles.answer}
                duration={280}
                height={isFaqOpen ? "auto" : 0}
            >
                <div className={styles.answerContent}>
                    <ReactMarkdown rehypePlugins={[rehypeRaw] as any}>
                        {answer}
                    </ReactMarkdown>
                </div>
            </AnimateHeight>
        </article>
    );
};

export default SingleFaq;
